import type { Type } from '@angular/core';
import { HowItWorksBingoalComponent } from '@app/components/tutorial/how-it-works-bingoal/how-it-works-bingoal.component';
import { HowItWorksCricketComponent } from '@app/components/tutorial/how-it-works-cricket/how-it-works-cricket.component';
import { HowItWorksDartsComponent } from '@app/components/tutorial/how-it-works-darts/how-it-works-darts.component';
import { HowItWorksFantasy15Component } from '@app/components/tutorial/how-it-works-fantasy15/how-it-works-fantasy15.component';
import { HowItWorksGoalRushComponent } from '@app/components/tutorial/how-it-works-goal-rush/how-it-works-goal-rush.component';
import { GamesTypes } from '@app/domain/enums/game';

export const HOW_IT_WORKS_CONTENT: Readonly<Partial<Record<GamesTypes, Type<unknown>>>> = {
  [GamesTypes.BINGOALS]: HowItWorksBingoalComponent,
  [GamesTypes.NOW]: HowItWorksBingoalComponent,
  [GamesTypes.CRICKET]: HowItWorksCricketComponent,
  [GamesTypes.DARTS]: HowItWorksDartsComponent,
  [GamesTypes.FANTASY15]: HowItWorksFantasy15Component,
  [GamesTypes.GOAL_RUSH]: HowItWorksGoalRushComponent,
} as const;
